module.exports = "/_next/static/images/im-bed05fde498a6a74bc21d2abfbfc33b4.svg";